import { css, htmlArray } from "../helpers/webComponents";
import { Page } from "../enums/Page";

/** CSS affecting the {@link NotebookComponent} */
const styles: string = css`
:host {
        font-family: "Onesize", sans-serif;
        width: 100%;
        max-width: 1024px;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url("assets/img/rooms/backgroundcomponent.png") no-repeat center center;
        background-size: cover;
    }

    .book {
        position: relative;
        width: 100%;
        max-width: 570px;
        height: auto;
        min-height: 450px;
        background: #E0D3AF;
        opacity: 0.9;
        border: 10px solid #9B111E;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
        font-family: "Onesize", sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 20px;
        overflow: auto;
    }

    h2 {
        font-family: "Onesize", sans-serif;
        text-align: center;
        font-size: 24px;
        color: #4B2E39;
        margin-bottom: 15px;
        text-transform: uppercase;
    }

    textarea {
        width: 100%;
        height: 100px;
        padding: 10px;
        font-size: 16px;
        border: 1px solid #6d6d6d;
        border-radius: 5px;
        background: #fff;
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        width: 100%;
        text-align: left;
        overflow: auto;
    }

    li {
        background: #4e4e4e;
        color: #ffd700;
        padding: 10px;
        margin: 5px 0;
        border-radius: 5px;
        font-size: 18px;
        border: 1px solid #6d6d6d;
    }

    .empty-message {
        font-style: italic;
        color: #bebbbb;
    }

    .notebook-button {
        background-color: #780606;
        border: 1px solid #6d6d6d;
        padding: 10px 20px;
        margin-top: 15px;
        text-transform: uppercase;
        cursor: pointer;
        display: block;
        width: 100%;
        text-align: center;
        color: white;
        border-radius: 5px;
    }

    .notebook-button:hover {
        background-color: #bebbbb;
        color: black;
    }
    
    .return-button {
        font-family: "Onesize", sans-serif;
        background-color: #780606;
        border: 1px solid #6d6d6d;
        padding: 10px 20px;
        margin-top: 15px;
        text-transform: uppercase;
        cursor: pointer;
        display: block;
        width: 100%;
        text-align: center;
        color: white;
        border-radius: 5px;
    }

    .return-button:hover {
        background-color: #bebbbb;
        color: black;
    }

    .deleteButton li {
    background: #4e4e4e;
    color: #ffd700;
    padding: 10px;
    margin: 5px 0;
    border-radius: 5px;
    font-size: 18px;
    border: 1px solid #6d6d6d;
    position: relative; /* Zorgt ervoor dat de deleteButton correct wordt gepositioneerd */
}

    .deleteButton {
    margin-left: 300px; 
    background-color: #780606;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
}

.deleteButton:hover {
    background-color: #bebbbb;
    color: black;
}
`;
export class NotebookComponent extends HTMLElement {
    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.render();
    }

    public connectedCallback(): void {
        this.setupEventListeners();
        void this.loadNotes();
    }

    private setupEventListeners(): void {
        if (!this.shadowRoot) return;

        const saveNoteBtn: HTMLElement | null = this.shadowRoot.getElementById("save-note");

        if (saveNoteBtn) {
            saveNoteBtn.addEventListener("click", () => this.saveNote());
        }
    }

    // private async saveNote(): Promise<void> {
    //     if (!this.shadowRoot) return;

    //     const noteInput: HTMLTextAreaElement | null = this.shadowRoot.querySelector("#note-input");
    //     if (!noteInput || noteInput.value.trim() === "") return;
    //     localStorage.setItem("playersessionId", result.sessionId);
    //     console.log("[Notebookcomponent] Session opgeslagen:", result.sessionId);

    //     try {
    //         await fetch("http://localhost:3001/notebook/check-code?" + new URLSearchParams({
    //             text: noteInput.value,
    //         }).toString());

    //         noteInput.value = "";
    //         await this.loadNotes();
    //     }
    //     catch (error) {
    //         console.error("Fout bij het opslaan van de notitie:", error);
    //     }
    // }

    private async saveNote(): Promise<void> {
        if (!this.shadowRoot) return;

        const noteInput: HTMLTextAreaElement | null = this.shadowRoot.querySelector("#note-input");
        if (!noteInput || noteInput.value.trim() === "") return;

        const playerSessionId: string | null = localStorage.getItem("playerSessionId");

        if (!playerSessionId) {
            console.error("Geen playerSessionId gevonden in localStorage");
            return;
        }

        try {
            await fetch("http://localhost:3001/notebook/check-code?" + new URLSearchParams({
                text: noteInput.value,
                playersessionId: playerSessionId,
            }).toString());

            noteInput.value = "";
            await this.loadNotes();
        }
        catch (error) {
            console.error("Fout bij het opslaan van de notitie:", error);
        }
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            <div class="book">
                <h2>Notebook</h2>
                <textarea id="note-input" placeholder="Type your note here..."></textarea>
                <button id="save-note" class="notebook-button">Save Note</button>
                <ul id="notes-list"></ul>
                <button class="return-button">Return to the game</button>
            </div>
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);

        const returnButton: Element | null = this.shadowRoot.querySelector(".return-button");
        returnButton?.addEventListener("click", () => this.returnToRoom());
    }

    private async loadNotes(): Promise<void> {
        if (!this.shadowRoot) return;

        const notesList: HTMLUListElement | null = this.shadowRoot.querySelector("#notes-list");
        if (!notesList) return;

        try {
            const response: Response = await fetch("http://localhost:3001/notebook/get-code");
            const notes: { id: number; text: string }[] = await response.json() as { id: number; text: string }[];
            console.log(notes);
            notesList.innerHTML = "";

            notes.forEach(note => {
                const li: HTMLLIElement = document.createElement("li");
                li.textContent = note.text;
                const deleteButton: HTMLButtonElement = document.createElement("button");
                deleteButton.textContent = "Delete";
                // deleteButton.id = "deleteButton";
                deleteButton.className = "deleteButton";
                deleteButton.addEventListener("click", async () => {
                    await this.deleteNote(note.id);
                });
                li.appendChild(deleteButton);
                notesList.appendChild(li);
            });
        }
        catch (error) {
            console.error("Fout bij het ophalen van notities:", error);
        }
    }

    private async deleteNote(id: number): Promise<void> {
        if (!this.shadowRoot) {
            return;
        }

        try {
            // const deleteButton: HTMLButtonElement = this.shadowRoot.querySelector("#deleteButton") as HTMLButtonElement;
            // console.log(deleteButton);
            await fetch(`http://localhost:3001/notebook/delete-code?id=${id}`);
            console.log("noteId:", id);
            //     + new URLSearchParams({
            //     id: deleteButton.value,
            // }).toString());
            // deleteButton.value = "";

            await this.loadNotes();
        }

        catch (error) {
            console.error("Fout bij het verwijderen van de notitie:", error);
        }
    }

    private returnToRoom(): void {
        const event: CustomEvent = new CustomEvent("game-switch-page", {
            detail: { page: Page.Canvas }, // Page.Canvas verwijst naar de game-canvas
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
}
